const scope = "traceAnalytics";
export default scope;